import React from 'react'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'

import Tank from '../Tank'
interface IProps {
  tanks: any[]
  onTankClick: (tankId: string) => void
}

const SmallScreen = ({ tanks, onTankClick }: IProps) => (
  <Grid container>
    {tanks.map(tank => (
      <Grid item key={tank.deviceID} xs={12} sm={4} lg={3} xl={2}>
        <Box py={{ xs: 1 }} mx={{ xs: 0, sm: 1 }} height="100%">
          <Tank tank={tank} onClick={onTankClick} source='mobile' />
        </Box>
      </Grid>
    ))}
  </Grid>
)

export default SmallScreen
